import React from "react";
import { X, Loader2 } from "lucide-react";
import "./ConfirmDialog.css";

function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  busy = false,
  busyLabel = "Aguarde...",
  danger = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div
      className="confirm-dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      onClick={() => {
        if (!busy) onCancel?.();
      }}
    >
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <h3 id="confirm-dialog-title">{title}</h3>
          <button
            type="button"
            className="confirm-dialog-close"
            onClick={() => {
              if (!busy) onCancel?.();
            }}
            aria-label="Fechar"
            disabled={busy}
          >
            <X size={20} />
          </button>
        </div>
        <div className="confirm-dialog-body">
          <p>{message}</p>
        </div>
        <div className="confirm-dialog-footer">
          <button
            type="button"
            className="confirm-dialog-cancel"
            onClick={() => onCancel?.()}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={
              danger ? "confirm-dialog-confirm confirm-dialog-confirm-danger" : "confirm-dialog-confirm"
            }
            onClick={() => onConfirm?.()}
            disabled={busy}
          >
            {busy ? (
              <>
                <Loader2 size={16} className="confirm-dialog-spinner" /> {busyLabel}
              </>
            ) : (
              confirmLabel
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
